module.exports = __webpack_public_path__ + "img/9-3.3665e7aa.png";